const LOGIN_DOMAIN_KEY = 'zen.login.dominio';

const KEYS = {
  token: 'token',
  refreshToken: 'refreshToken',
  userName: 'userName',
  userId: 'userId',
  slug: 'slug',
  perfil: 'perfil',
  perfilId: 'perfilId',
  permissoes: 'permissoes',
  modulosLicenca: 'modulosLicenca',
  modulosAtivos: 'modulosAtivos',
  empresasPermitidas: 'empresasPermitidas',
  estabelecimentosPermitidos: 'estabelecimentosPermitidos',
  acessoTodasFiliais: 'acessoTodasFiliais',
  licencaBloqueio: 'licencaBloqueio',
  licencaAviso: 'licencaAviso',
  licencaAvisoEm: 'licencaAvisoEm',
};

/** Migra chaves antigas de sessionStorage → localStorage (uma vez). */
function migrateFromSession() {
  try {
    if (localStorage.getItem(KEYS.token)) return;
    const legacy = sessionStorage.getItem(KEYS.token);
    if (!legacy) return;
    Object.values(KEYS).forEach((key) => {
      const value = sessionStorage.getItem(key);
      if (value != null) {
        localStorage.setItem(key, value);
        sessionStorage.removeItem(key);
      }
    });
  } catch {
    /* ignore */
  }
}

migrateFromSession();

export function getAuthToken() {
  return localStorage.getItem(KEYS.token) || '';
}

export function getRefreshToken() {
  return localStorage.getItem(KEYS.refreshToken) || '';
}

export function getAuthSlug() {
  return (
    localStorage.getItem(KEYS.slug) ||
    localStorage.getItem(LOGIN_DOMAIN_KEY) ||
    ''
  );
}

export function getAuthUserName() {
  return localStorage.getItem(KEYS.userName) || '';
}

export function getAuthUserId() {
  return localStorage.getItem(KEYS.userId) || '';
}

export function getAuthPermissoes() {
  try {
    return JSON.parse(localStorage.getItem(KEYS.permissoes) || 'null');
  } catch {
    return null;
  }
}

export function getAuthModulosLicenca() {
  try {
    return JSON.parse(localStorage.getItem(KEYS.modulosLicenca) || '[]');
  } catch {
    return [];
  }
}

export function getAuthModulosAtivos() {
  try {
    return JSON.parse(localStorage.getItem(KEYS.modulosAtivos) || '[]');
  } catch {
    return [];
  }
}

export function getAuthEmpresasPermitidas() {
  const raw = localStorage.getItem(KEYS.empresasPermitidas);
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

export function getAuthEstabelecimentosPermitidos() {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEYS.estabelecimentosPermitidos) || '[]');
    return Array.isArray(parsed)
      ? parsed.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0)
      : [];
  } catch {
    return [];
  }
}

export function getAuthAcessoTodasFiliais() {
  return localStorage.getItem(KEYS.acessoTodasFiliais) === 'true';
}

export function getLicencaBloqueio() {
  return localStorage.getItem(KEYS.licencaBloqueio) || '';
}

export function setLicencaBloqueio(mensagem) {
  const atual = getLicencaBloqueio();
  const proxima = (mensagem || '').trim();
  if (proxima) {
    localStorage.setItem(KEYS.licencaBloqueio, proxima);
  } else {
    localStorage.removeItem(KEYS.licencaBloqueio);
  }
  if (atual !== proxima) {
    window.dispatchEvent(new CustomEvent('zen:licenca-atualizada'));
  }
}

export function getLicencaAviso() {
  return localStorage.getItem(KEYS.licencaAviso) || '';
}

export function getLicencaAvisoEm() {
  return localStorage.getItem(KEYS.licencaAvisoEm) || '';
}

export function setLicencaAviso(mensagem, bloqueioProgramadoEm = '') {
  const atual = getLicencaAviso();
  const proxima = (mensagem || '').trim();
  const em = (bloqueioProgramadoEm || '').trim();
  if (proxima) {
    localStorage.setItem(KEYS.licencaAviso, proxima);
    if (em) localStorage.setItem(KEYS.licencaAvisoEm, em);
    else localStorage.removeItem(KEYS.licencaAvisoEm);
  } else {
    localStorage.removeItem(KEYS.licencaAviso);
    localStorage.removeItem(KEYS.licencaAvisoEm);
  }
  if (atual !== proxima) {
    window.dispatchEvent(new CustomEvent('zen:licenca-atualizada'));
  }
}

export function setAuthSession(data = {}) {
  if (data.token != null) localStorage.setItem(KEYS.token, data.token);
  if (data.refreshToken != null) {
    localStorage.setItem(KEYS.refreshToken, data.refreshToken);
  }
  if (data.userName != null) localStorage.setItem(KEYS.userName, data.userName);
  if (data.userId != null) localStorage.setItem(KEYS.userId, String(data.userId));
  if (data.slug != null) localStorage.setItem(KEYS.slug, data.slug);
  if (data.perfil != null) localStorage.setItem(KEYS.perfil, data.perfil);
  if (data.perfilId != null) {
    localStorage.setItem(KEYS.perfilId, String(data.perfilId));
  }
  if (data.permissoes != null) {
    localStorage.setItem(KEYS.permissoes, JSON.stringify(data.permissoes));
  }
  if (data.modulos != null) {
    localStorage.setItem(KEYS.modulosLicenca, JSON.stringify(data.modulos));
    window.dispatchEvent(new CustomEvent('zen:licenca-atualizada'));
  }
  if (data.modulosAtivos != null) {
    localStorage.setItem(KEYS.modulosAtivos, JSON.stringify(data.modulosAtivos));
  }
  if (data.empresasPermitidas != null) {
    localStorage.setItem(KEYS.empresasPermitidas, String(data.empresasPermitidas));
  }
  if (data.estabelecimentosPermitidos != null) {
    localStorage.setItem(
      KEYS.estabelecimentosPermitidos,
      JSON.stringify(data.estabelecimentosPermitidos),
    );
  }
  if (data.acessoTodasFiliais != null) {
    localStorage.setItem(KEYS.acessoTodasFiliais, data.acessoTodasFiliais ? 'true' : 'false');
  }
}

export function clearAuth() {
  Object.values(KEYS).forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
}

export function hasAuthToken() {
  return Boolean(getAuthToken());
}
